import * as v from "valibot";
import { rpcContract } from "../rpc";

export const getPublicLiveEventsRpcContract = rpcContract({
  name: "get-public-live-events",
  paramsSchema: v.object({
    handle: v.string(),
    includeEndedEvents: v.optional(v.boolean()),
  }),
  resultSchema: v.object({
    events: v.array(
      v.object({
        id: v.string(),
        title: v.string(),
        description: v.nullable(v.string()),
        content_tier: v.string(),
        fee_cents: v.nullable(v.number()),
        status: v.string(),
        scheduled_start_time: v.string(),
        actual_start_time: v.nullable(v.string()),
        end_time: v.nullable(v.string()),
        max_attendees: v.nullable(v.number()),
        current_attendee_count: v.number(),
        thumbnail_url: v.nullable(v.string()),
        thumbnail_path: v.nullable(v.string()),
        post_buying_video_url: v.nullable(v.string()),
        whatsapp_url: v.nullable(v.string()),
        cta_text: v.nullable(v.string()),
        language: v.optional(v.nullable(v.string())),
        stream_delivery: v.optional(v.string()),
        expected_duration: v.nullable(v.number()),
        peak_viewer_count: v.number(),
        created_at: v.string(),
        updated_at: v.string(),
        hasAccess: v.boolean(),
        influencer_id: v.string(),
        influencer_handle: v.nullable(v.string()),
        is_co_promoted: v.optional(v.boolean()),
        owner_handle: v.optional(v.nullable(v.string())),
        owner_display_name: v.optional(v.nullable(v.string())),
        owner_avatar_url: v.optional(v.nullable(v.string())),
        collaborators: v.optional(
          v.array(
            v.object({
              handle: v.string(),
              displayName: v.nullable(v.string()),
              avatarUrl: v.nullable(v.string()),
            }),
          ),
        ),
        community_only: v.boolean(),
        community_ids: v.optional(v.array(v.string())),
        is_community_member: v.optional(v.boolean()),
        recording_status: v.optional(v.nullable(v.string())),
        recording_url: v.optional(v.nullable(v.string())),
        linked_items: v.array(
          v.object({
            id: v.string(),
            title: v.nullable(v.string()),
            teaser: v.nullable(v.string()),
            thumbnail: v.nullable(v.string()),
            url: v.nullable(v.string()),
            has_discount: v.boolean(),
            code: v.nullable(v.string()),
            brand: v.nullable(
              v.object({
                id: v.string(),
                name: v.string(),
                thumbnail: v.nullable(v.string()),
              }),
            ),
            promotion_file: v.nullable(
              v.object({
                id: v.string(),
                path: v.string(),
                thumbnail_path: v.nullable(v.string()),
                mime_type: v.nullable(v.string()),
              }),
            ),
          }),
        ),
      }),
    ),
  }),
});

export type GetPublicLiveEventsParams = v.InferOutput<(typeof getPublicLiveEventsRpcContract)["paramsSchema"]>;
export type GetPublicLiveEventsResult = v.InferOutput<(typeof getPublicLiveEventsRpcContract)["resultSchema"]>;
